import React from "react"
import { useMatch } from "react-router-dom"
import { BreadCrumbs } from "ui/BreadCrumbs"

export const ResourcesBreadcrumb = () => {
  // Check if we're on equipment or crew details page
  const matchEquipmentDetail = useMatch("/pro/home/resources/equipment/:id")
  const matchCrewDetail = useMatch("/pro/home/resources/crew/:id")

  const isEquipmentDetail = !!matchEquipmentDetail
  const isCrewDetail = !!matchCrewDetail

  let subPages = []
  if (isEquipmentDetail) {
    subPages = ["Resource details"]
  } else if (isCrewDetail) {
    subPages = ["Crew member details"]
  }

  return <BreadCrumbs iconName="boat" category="Resources" subPages={subPages} />
}
